import { createSlice } from "@reduxjs/toolkit";
import { PartnerInterface } from "../../components/Partners/types";

interface props {
  isFetching: boolean,
  partners: PartnerInterface[],
  error: string[]
}
const initialState: props = {
  isFetching: false,
  partners: [],
  error: []
}
const partnerSlice = createSlice({
  name: "partners",
  initialState,
  reducers: {
    statusPartnerStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusPartnerSuccess: (state, action) => {
      state.isFetching = false
      state.partners = action.payload
      state.error = []
    },
    statusPartnerFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})


export const { 
  statusPartnerStart,
  statusPartnerSuccess,
  statusPartnerFailure 
} = partnerSlice.actions

export default partnerSlice.reducer